import {connect} from 'react-redux';
import UsersList from '../components/AdminPanel/Users/UsersList';
import userActions from '../actions/usersActions';
import { updateUser } from '../components/AdminPanel/Users/actions';

const mapStateToProps = (state) => {
    const {users} = state;
    return {
        users: users.list,
        isLoading: users.isLoading,
        isOpen: users.isOpen,
        total: users.total,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        getUsers: (body) => dispatch(userActions.getUsers(body)),
        updateUser: (user) => dispatch(updateUser(user)),
        onOpenUserModal: (show) => dispatch(userActions.toggleOpenUserModal(show)),
        onChangeStatus: (userId, status) => dispatch(userActions.setStatus(userId, status)),
        onChangeAccount: (userId, type) => dispatch(userActions.setAccount(userId, type)),
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(UsersList)



// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/containers/UsersListConatiner.js